import { render, staticRenderFns } from "./Projectpatent.vue?vue&type=template&id=60811411&scoped=true&"
import script from "./Projectpatent.vue?vue&type=script&lang=js&"
export * from "./Projectpatent.vue?vue&type=script&lang=js&"
import style0 from "./Projectpatent.vue?vue&type=style&index=0&id=60811411&scoped=true&lang=css&"
import style1 from "./Projectpatent.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60811411",
  null
  
)

export default component.exports